export default __webpack_public_path__ + "static/media/Tinder.6efb046d.png";